import { render } from "./UpdateParcel.vue?vue&type=template&id=118f1e89&ts=true"
import script from "./UpdateParcel.vue?vue&type=script&lang=ts"
export * from "./UpdateParcel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__